import React, { Component } from "react";
import { connect } from "react-redux";
import Button from "react-bootstrap-button-loader";
import _ from "lodash";
import Addreports from "./add-report";
import LocaleStrings from "Languages";

class ReportissueHeader extends Component {
  constructor(props) {
    super(props);

    this.state = { isOpen: false };
  }

  openModal = () => {
    this.setState({ isOpen: true });
  };

  closeModal = () => {
    this.setState({ isOpen: false });
  };

  render() {
    return (
      <div className="content-header-bar">
        <div className="vertical-align-center">
          <div>
            <div className="custom-text1-primary-medium">
              {LocaleStrings.accountsetting_reportissue_headertitle}
            </div>
            <div className="custom-text2-secondary-normal">
              {LocaleStrings.accountsetting_reportissue_headerdesc}
            </div>
          </div>
        </div>

        <ul className="header-buttons">
          <li>
            <Button
              className="btn-custom-blue"
              onClick={() => this.openModal()}
            >
              <img
                src="../../style/images/header-icons/plus.png"
                style={{ paddingRight: "10px", paddingBottom: "3px" }}
              />
              {LocaleStrings.button_add}
            </Button>
          </li>
        </ul>

        {this.state.isOpen ? (
          <Addreports isOpen={this.state.isOpen} onClose={this.closeModal} />
        ) : (
          ""
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  var { session, user } = state;
  return {
    session,
    user,
    deviceSize: state.deviceSize,
  };
}

export default connect(mapStateToProps, {})(ReportissueHeader);
